import PocketBase from 'pocketbase';

// Conteneur unique : PocketBase sert le frontend depuis la même origine en
// prod. En dev, `pocketbase serve` tourne sur un port séparé de Parcel.
const PB_URL = process.env.PB_URL || window.location.origin;

export const pb = new PocketBase(PB_URL);

export async function initAuthRefresh(): Promise<void> {
  if (!pb.authStore.isValid) return;
  try {
    await pb.collection('users').authRefresh();
  } catch {
    pb.authStore.clear();
  }
}
